{
  "labels": {
    "paste": "पेस्ट",
    "pasteAsPlaintext": "सादे पाठ के रूप में चिपकाएं",
    "pasteCharts": "चार्ट चिपकाएँ",
    "selectAll": "सेलेक्ट ऑल",
    "multiSelect": "अवयव को चयन में सम्मिलित करें",
    "moveCanvas": "चित्रपटल को स्थानांतरित करें",
    "cut": "काटें",
    "copy": "प्रतिलिपि बनाएँ",
    "copyAsPng": "क्लिपबोर्ड पर पीएनजी के रूप में प्रतिलिपि बनायें",
    "copyAsSvg": "क्लिपबोर्ड पर एसवीजी के रूप में प्रतिलिपि बनायें",
    "copyText": "पाठ के रूप में क्लिपबोर्ड पर प्रतिलिपि बनायें",
    "copySource": "स्त्रोत रूप में क्लिपबोर्ड पर प्रतिलिपि बनाएँ",
    "convertToCode": "सांकेतिक लिपि में परिवर्तित करे",
    "bringForward": "सबसे सामने लाएं",
    "sendToBack": "पीछे भेजें",
    "bringToFront": "सामने लायें",
    "sendBackward": "सबसे पीछे भेजे",
    "delete": "हटायें",
    "copyStyles": "अंदाज़ की प्रतिलिपि बनायें",
    "pasteStyles": "अंदाज़ चिपकाये",
    "stroke": "रेखा",
    "changeStroke": "कूँची का रंग बदले",
    "background": "पृष्ठभूमि",
    "changeBackground": "पृष्ठभूमि का रंग बदले",
    "fill": "भरें",
    "strokeWidth": "रेखा की चौड़ाई",
    "strokeStyle": "स्ट्रोक का अंदाज़",
    "strokeStyle_solid": "ठोस",
    "strokeStyle_dashed": "डैश",
    "strokeStyle_dotted": "बिंदीदार",
    "sloppiness": "बेढ़ंगापन",
    "opacity": "अपारदर्शिता",
    "textAlign": "पाठ्य संरेखन",
    "edges": "किनारे",
    "sharp": "तीखा",
    "round": "गोलाकार",
    "arrowheads": "तीर शीर्ष",
    "arrowhead_none": "कोई भी नहीं",
    "arrowhead_arrow": "तीर",
    "arrowhead_bar": "छड़",
    "arrowhead_circle": "वृत्त",
    "arrowhead_circle_outline": "वृत्त (बाह्यरेखा)",
    "arrowhead_triangle": "त्रिकोण",
    "arrowhead_triangle_outline": "त्रिभुज (बाह्यरेखा)",
    "arrowhead_diamond": "ईंट",
    "arrowhead_diamond_outline": "ईंट (बाह्यरेखा)",
    "arrowhead_crowfoot_many": "चिड़िया पैर (अनेक)",
    "arrowhead_crowfoot_one": "चिड़िया पैर (एक)",
    "arrowhead_crowfoot_one_or_many": "चिड़िया पैर (एक या अनेक)",
    "more_options": "और विकल्प",
    "arrowtypes": "तीर प्रकार",
    "arrowtype_sharp": "तीक्ष्ण तीर",
    "arrowtype_round": "गोलाकार तीर",
    "arrowtype_elbowed": "कोहनी तीर",
    "fontSize": "अक्षर का आकार",
    "fontFamily": "अक्षर वर्ग",
    "addWatermark": "\"एक्स काली ड्रॉ द्वारा बनाया हुवा\" जोड़े",
    "handDrawn": "हस्त रेखित",
    "normal": "सामान्य",
    "code": "सांकेतिक लिपि",
    "small": "छोटा",
    "medium": "मध्यम",
    "large": "बड़ा",
    "veryLarge": "बहुत बड़ा",
    "solid": "दृढ़",
    "hachure": "हैशूर",
    "zigzag": "तेढ़ी मेढ़ी",
    "crossHatch": "क्रॉस हैच",
    "thin": "महीन",
    "bold": "मोटा",
    "left": "बायें",
    "center": "मध्य",
    "right": "दायें",
    "extraBold": "बहुत मोटा",
    "architect": "वास्तुकार",
    "artist": "कलाकार",
    "cartoonist": "व्यंग्य चित्रकार",
    "fileTitle": "फ़ाइल का नाम",
    "colorPicker": "रंग चयन",
    "canvasColors": "कॅनवास पर प्रयोगित",
    "canvasBackground": "चित्रपटल पृष्ठभूमि",
    "drawingCanvas": "चित्रपटल",
    "clearCanvas": "चित्रपलट स्वच्छ करे",
    "layers": "परतें",
    "actions": "कार्रवाई",
    "language": "भाषा",
    "liveCollaboration": "जीवंत सहयोग...",
    "duplicateSelection": "प्रतिरूप",
    "untitled": "अशीर्षित",
    "name": "नाम",
    "yourName": "आपका नाम",
    "madeWithExcalidraw": "एक्स काली ड्रॉ द्वारा बनाया हुवा",
    "group": "समूह चयन",
    "ungroup": "समूह चयन असमूहीकृत करें",
    "collaborators": "सहयोगी",
    "toggleGrid": "जाली दिखना टॉगल करें",
    "addToLibrary": "लाइब्रेरी में सम्मिलित करें",
    "removeFromLibrary": "समूहकोष से अलग करें",
    "libraryLoadingMessage": "समूहकोष खुल रहा है",
    "libraries": "समूह कोष पड़तालें",
    "loadingScene": "दृश्य खुल रहा है",
    "loadScene": "फ़ाइल से दृश्य लायें",
    "align": "संरेखित करें",
    "alignTop": "ऊपर संरेखित करें",
    "alignBottom": "नीचे संरेखित करें",
    "alignLeft": "बायें संरेखित करें",
    "alignRight": "दायें संरेखित करें",
    "centerVertically": "लंबवत केन्द्रित",
    "centerHorizontally": "क्षैतिज केन्द्रित",
    "distributeHorizontally": "क्षैतिज रूप से वितरित करें",
    "distributeVertically": "लंबवत वितरित करें",
    "flipHorizontal": "दायें बायें पलटे",
    "flipVertical": "ऊपर नीचे पलटे",
    "viewMode": "देखने के प्रकार",
    "share": "साझा करें",
    "showStroke": "कूँची रंग चयक दिखायें",
    "showBackground": "पृष्ठभूमि रंग चयक दिखाये",
    "showFonts": "लिपि चुनक दिखायें",
    "toggleTheme": "अंधेरी/उजेलि संरचना पलटे",
    "theme": "संरचना पद्धति",
    "personalLib": "वैयक्तिक समूहकोष",
    "excalidrawLib": "एक्सकेलीड्रॉ समूहकोष",
    "decreaseFontSize": "अक्षर आकार घटायें",
    "increaseFontSize": "अक्षर आकार बढ़ायें",
    "unbindText": "लिपि को बंधमुक्त करें",
    "bindText": "पाठ्य को कोष से जोड़े",
    "createContainerFromText": "पाठ्य कोष में मोड के दिखायें",
    "link": {
      "edit": "कड़ी संपादित करे",
      "editEmbed": "अंतर्निहित-कड़ी संपादन",
      "create": "कड़ी जोड़े",
      "label": "कड़ी",
      "labelEmbed": "कड़ी और जड़ना",
      "empty": "कोई कड़ी नहीं हैं",
      "hint": "अपनी कड़ी टाइप करे अथवा कड़ी चिपकाए",
      "goToElement": "निर्धारित तत्व की तरफ जाए"
    },
    "lineEditor": {
      "edit": "रेखा संपादित करे",
      "editArrow": "तीर संपादन"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": "बहुभुज में कनवर्ट करें"
    },
    "elementLock": {
      "lock": "ताले में रखें",
      "unlock": "ताला खोलें",
      "lockAll": "सब ताले के अंदर रखे",
      "unlockAll": "सब ताले के बाहर निकाले"
    },
    "statusPublished": "प्रकाशित",
    "sidebarLock": "साइडबार खुला रखे.",
    "selectAllElementsInFrame": "चौखट के सर्व अवयव चुने",
    "removeAllElementsFromFrame": "चौखट से सर्व अवयव हटायें",
    "eyeDropper": "चित्रफलक से रंग चुने",
    "textToDiagram": "पाठ से रेखाचित्र",
    "prompt": "प्रश्न",
    "followUs": "हमारा अनुकरण करें",
    "discordChat": "डिस्कॉर्ड संवाद",
    "zoomToFitViewport": "दृश्यचौखट में पूरी तरह से बैठने के लिए झूम करें.",
    "zoomToFitSelection": "चयन पूरा दिखने इतना झूम करे",
    "zoomToFit": "सभी तत्व दिखे इतना झूम करें",
    "installPWA": "एक्सकाली ड्रॉ को स्थानीयरूप में इंस्टॉल करें (PWA)",
    "autoResize": "स्वयं आकार पुनः निर्धारण",
    "imageCropping": "प्रतिमा काटना",
    "unCroppedDimension": "कटाई पूर्व आयाम",
    "copyElementLink": "वस्तु की कड़ी कॉपी करें",
    "linkToElement": "वस्तु की कड़ी",
    "wrapSelectionInFrame": "चौकट में चुने हुवे को लपेटे",
    "tab": "",
    "shapeSwitch": "आकार बदलें"
  },
  "elementLink": {
    "title": "वस्तु की कड़ी",
    "desc": "चित्र-पटल पर किसी आकार पर क्लिक करें अथवा कड़ी को चिपकाये",
    "notFound": "चित्र-पटल पर कड़ी वाली वस्तु नहीं मिली"
  },
  "library": {
    "noItems": "अभी तक कोई अवयव जोडा नहीं गया.",
    "hint_emptyLibrary": "यहाँ जोड़ने के लिए चित्रपटल से एक अवयव चुने, अथवा जन कोष से एक संग्रह नीचे स्थापित करें.",
    "hint_emptyPrivateLibrary": "यहाँ जोड़ने के लिए चित्रपटल से एक अवयव चुने.",
    "search": {
      "inputPlaceholder": "लाइब्रेरी में खोजें",
      "heading": "लाइब्रेरी मैच",
      "noResults": "कोई मिलता जुलता नहीं मिला |||",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "पटल पर धूंडे",
    "noMatch": "कोई मिलता जुलता नहीं मिला",
    "singleResult": "परिणाम",
    "multipleResults": "परिणाम",
    "placeholder": "पटल पर पाठ्य धूंडे",
    "frames": "फ्रेम्स",
    "texts": "शब्द"
  },
  "buttons": {
    "clearReset": "चित्रपटल स्वच्छ करें",
    "exportJSON": "फ़ाइल में निर्यात करें",
    "exportImage": "प्रतिमा निर्यात करे...",
    "export": "यंहा सुरक्षित करे...",
    "copyToClipboard": "क्लिपबोर्ड पर प्रतिलिपि बनाएँ",
    "copyLink": "लिंक कॉपी करें",
    "save": "वर्तमान फ़ाईल में सुरक्षित करें",
    "saveAs": "सेव करे इस तरह",
    "load": "खोलें",
    "getShareableLink": "साझा करने योग्य लिंक प्राप्त करें",
    "close": "बंद करें",
    "selectLanguage": "भाषा चुनें",
    "scrollBackToContent": "सामग्री पर वापस स्क्रॉल करें",
    "zoomIn": "बड़ा करें",
    "zoomOut": "छोटा करें",
    "resetZoom": "बड़ा छोटा करना पहले जैसा करें",
    "menu": "चयन सूची",
    "done": "समाप्त",
    "edit": "संपादित करें",
    "undo": "पूर्ववत् करें",
    "redo": "फिर से करें",
    "resetLibrary": "संग्रह को पुनः स्थापित करें",
    "createNewRoom": "एक नया कमरा बनाएं",
    "fullScreen": "पूर्ण दृश्यपटल",
    "darkMode": "कम प्रकाश प्रणाली",
    "lightMode": "अधिक प्रकाश प्रणाली",
    "systemMode": "तांत्रिक प्रणाली",
    "zenMode": "एकाग्र प्रणाली",
    "objectsSnapMode": "वस्तुओं से पकड़े",
    "exitZenMode": "एकाग्र स्थिति से बाहर निकलें",
    "cancel": "रद्द करें",
    "saveLibNames": "",
    "clear": "साफ़ करे",
    "remove": "हटाएं",
    "embed": "जड़ना पलटें",
    "publishLibrary": "",
    "submit": "प्रस्तुत करे",
    "confirm": "पुष्टि करें",
    "embeddableInteractionButton": "संवाद स्थापना के लिए क्लिक करें"
  },
  "alerts": {
    "clearReset": "इससे पूरा चित्रपटल साफ हो जाएगा। क्या आप निश्चित है?",
    "couldNotCreateShareableLink": "साझा करने योग्य लिंक नहीं बनाया जा सका।",
    "couldNotCreateShareableLinkTooBig": "कड़ी साझा नहीं की जा सकती कारण: दृश्य बहुत बड़ा हैं",
    "couldNotLoadInvalidFile": "अमान्य फ़ाइल लोड नहीं की जा सकी",
    "importBackendFailed": "बैकएंड से आयात करना विफल रहा।",
    "cannotExportEmptyCanvas": "खाली चित्रपटल निर्यात नहीं कर सकते",
    "couldNotCopyToClipboard": "क्लिपबोर्ड पर कॉपी नहीं किया जा सका",
    "decryptFailed": "डेटा को विसंकेतन नहीं किया जा सका।",
    "uploadedSecurly": "अपलोड को आद्यंत एन्क्रिप्शन के साथ सुरक्षित किया गया है, जिसका मतलब है कि एक्सकालीड्रॉ सर्वर और अन्य पक्ष आपका पाठ्य नहीं पढ़ सकते हैं।",
    "loadSceneOverridePrompt": "बाहरी रेखाचित्र आयत करने से वह आपके मौजूदा सामग्री को बदल/हटा देगा। क्या आप इसे होने देना चाहते हैं?",
    "collabStopOverridePrompt": "चालू सत्र के समाप्ति से आपका संग्रहित पूर्व स्थानीय अधिलेखन नष्ट होकर पुनः अधिलेखित होगा, क्या आपको यक़ीन हैं? ( यदी आपको पूर्व स्थापित अधिलेखन सुरक्षित चाहिये तो बस ब्राउज़र टैब बंद करे)",
    "errorAddingToLibrary": "संग्रह में जोडा न जा सका",
    "errorRemovingFromLibrary": "संग्रह से हटाया नहीं जा सका",
    "confirmAddLibrary": "{{numShapes}} आकार आपके संग्रह में जुड़ेंगे, क्या उसे होने देना चाहते हों?",
    "imageDoesNotContainScene": "ऐसा लगता है कि इस छवि में कोई दृश्य डेटा नहीं है। क्या आपने निर्यात के दौरान दृश्य जड़ने की अनुमति दी है?",
    "cannotRestoreFromImage": "प्रतिमा फ़ाइल से दृश्य पुनःस्थापित न हो सका",
    "invalidSceneUrl": "दिये गये यु-आर-एल से दृश्य आयात नहीं किया जा सका. यह यू-आर-एल या तो अयोग्य है, या इसमें उचित एक्स-काली-ड्रॉ JSON डेटा नहीं है।",
    "resetLibrary": "यह पूरा संग्रह रिक्त करेगा. क्या आप इसे होने देना चहाते हों?",
    "removeItemsFromsLibrary": "{{count}} वस्तु(यें) संग्रह से हटायें?",
    "invalidEncryptionKey": "कूटलेखन कुंजी 22 अक्षरों की होनी चाहिये, इसलिये जीवंत सहयोग अक्षम हैं",
    "collabOfflineWarning": "कोई इंटरनेट कनेक्शन उपलब्ध नहीं है।\nआपके बदलाव सहेजे नहीं जाएंगे!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "असमर्थित फाइल प्रकार",
    "imageInsertError": "प्रतिमा सन्निवेश नहीं की जा सकी. पुनः प्रयत्न करे...",
    "fileTooBig": "फ़ाइल ज़रूरत से ज़्यादा बड़ी हैं. अधिकतम अनुमित परिमाण {{maxSize}} हैं",
    "svgImageInsertError": "एसवीजी प्रतिमा सम्मिलित नहीं कर सके, एसवीजी संरचना लगता है कि अयोग्य हैं.",
    "failedToFetchImage": "प्रतिमा लाने में विफल.",
    "cannotResolveCollabServer": "कॉलेब सर्वर से कनेक्शन नहीं हो पा रहा. कृपया पृष्ठ को पुनः लाने का प्रयास करे.",
    "importLibraryError": "संग्रह प्रतिष्ठापित नहीं किया जा सका",
    "saveLibraryError": "संग्रह सुरक्षित नहीं किया जा सका. कृपया अपने संग्रह को एक स्थानीय फ़ाइल में सुरक्षित करें जिससे आपके परिवर्तनों सुरक्षित रहेंगे.",
    "collabSaveFailed": "किसी कारण वश अंदरूनी डेटाबेस में सुरक्षित नहीं जा सका। यदि समस्या बनी रहती है, तो किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सुरक्षित करें.",
    "collabSaveFailed_sizeExceeded": "लगता है कि पृष्ठ तल काफ़ी बड़ा है, इस्कारण अंदरूनी डेटाबेस में सहेजा नहीं जा सका। किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सहेजे।",
    "imageToolNotSupported": "प्रतिमायें निर्योग्य की गयी हैं",
    "brave_measure_text_error": {
      "line1": "लगता है कि आप Brave ब्राउज़र का उपयोग कर रहे और साथ में <bold>आक्रामक उँगलियो के छाप निरोधन </bold> का चयन किया हुवा है",
      "line2": "यह आपके चित्रों के <bold>पाठ अवयवों</bold>को खंडित कर सकता हैं",
      "line3": "हमें आपसे ठोस आग्रह है की आप सेट्टिंग में इस विकल्प का चयन ना करे.<link> इस अनुक्रम </link> का पालन करके ये कैसे करे, इसका पता लगा सकते हैं",
      "line4": "यदि इस सेटिंग्स को अक्षम करने पर भी पृष्ठ ठीक नहीं दिखता हो तो, हमारे GitHub पर एक <issueLink>मुद्दा प्रस्तुत</issueLink> करे, या हमें <discordLink>डिस्कोर्ड</discordLink> पर लिखित सम्पर्क करें"
    },
    "libraryElementTypeError": {
      "embeddable": "जड़ने लायक़ अवयवों को समूहकोष में जोडा नहीं जा सका.",
      "iframe": "आइफ़्रेम के अवयवों को समूहकोष में जोडा नहीं जा सका.",
      "image": "प्रतिमायें समूह कोष में जोड़ना शीघ्र ही संभव होगा!"
    },
    "asyncPasteFailedOnRead": "चिपकाया नहीं जा सका (सिस्टम क्लिपबोर्ड से पढ़ा नहीं जा सका).",
    "asyncPasteFailedOnParse": "चिपकाया नहीं जा सका.",
    "copyToSystemClipboardFailed": "क्लिपबोर्ड पर प्रतिलिपि नहीं बनाई जा सकी."
  },
  "toolBar": {
    "selection": "चयन",
    "lasso": "लासो सलेक्शन",
    "image": "प्रतिमा सम्मिलित करें",
    "rectangle": "आयात",
    "diamond": "ईंट",
    "ellipse": "दीर्घवृत्त",
    "arrow": "तीर",
    "line": "रेखा",
    "freedraw": "चित्रांतित करे",
    "text": "पाठ",
    "library": "संग्रह",
    "lock": "ड्राइंग के बाद चयनित उपकरण को सक्रिय रखें",
    "penMode": "पेन का अंदाज़ - स्पर्श टाले",
    "link": "चयनित आकृति की कड़ी जोड़े/अद्यतन करें",
    "eraser": "रबड़",
    "frame": "चौखट उपकरण",
    "magicframe": "तारिक ढाँचें को सांकेतिक लिपि में",
    "embeddable": "वेब जड़ायें",
    "laser": "लेसर टॉर्च",
    "hand": "हाथ ( खिसका के देखने का औज़ार)",
    "extraTools": "अधिक उपकरण",
    "mermaidToExcalidraw": "मर्मेड से एक्सकाली में",
    "convertElementType": "आकार प्रकार टॉगल करें"
  },
  "element": {
    "rectangle": "आयत",
    "diamond": "ईंट",
    "ellipse": "दीर्घवृत्त",
    "arrow": "तीर",
    "line": "रेखा",
    "freedraw": "मुक्त चित्रांकन",
    "text": "पाठ",
    "image": "छवि",
    "group": "समूह",
    "frame": "ढांचा",
    "magicframe": "तारिक ढाँचें को सांकेतिक लिपि में",
    "embeddable": "वेब जडें",
    "selection": "चयन",
    "iframe": "आईफ्रेम"
  },
  "headings": {
    "canvasActions": "कैनवास क्रिया",
    "selectedShapeActions": "चयनित आकृति क्रियाएं",
    "shapes": "आकृतियाँ"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "कई बिंदुओं को शुरू करने के लिए क्लिक करें, एकमात्र रेखा के लिए खींचें",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "क्लिक करें और खींचें। समाप्त करने के लिए, छोडे",
    "text": "आप चयन उपकरण से कहीं भी डबल-क्लिक करके पाठ्य को जोड़ सकते हों",
    "embeddable": "वेबसाइट बनाकर जड़ने के लिए क्लिक-ड़्रैग करें",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "आपका अपना समूहकोष प्रकाशित करे",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "\"dom.events.asyncClipboard.clipboardItem\" फ़्लैग को \"true\" पर सेट करके इस सुविधा को संभवतः सक्षम किया जा सकता है। Firefox में ब्राउज़र फ़्लैग बदलने के लिए, \"about:config\" पृष्ठ पर जाएँ।",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "पूर्वावलोकन नहीं दिखा सकते हैं",
    "canvasTooBig": "चित्रपटल शायद बहुत बड़ा हो सकता हैं",
    "canvasTooBigTip": "सुझाव: सबसे दूर वाले अवयवों को थोड़ा आपस में पास-पास लायें."
  },
  "errorSplash": {
    "headingMain": "एक त्रुटि का सामना करना पड़ा।</button> पृष्ठ को पुनः लोड </button> करने का प्रयत्न करें.",
    "clearCanvasMessage": "यदि पुनः लोड करना काम नहीं करता है, <button>चित्रपटल साफ</button> करने का प्रयास करें.",
    "clearCanvasCaveat": " इससे किए हुये कार्य का नुकसान होगा ",
    "trackedToSentry": "पहचानकर्ता के साथ त्रुटि {{eventId}} पर हमारे सिस्टम ने नज़र रखी हुये थी।",
    "openIssueMessage": "हम बहुत सतर्क थे कि त्रुटि विवरण में आपके दृश्य कीजानकारी शामिल न हों। यदि आपका दृश्य निजी नहीं है, तो कृपया हमसे <button>बग ट्रैकर</button> पर सम्पर्क बनाए रख़े. कृपया GitHub मुद्दे में, नीचे दी गई जानकारी कॉपी और पेस्ट करके शामिल करें।",
    "sceneContent": "दृश्य सामग्री:"
  },
  "shareDialog": {
    "or": "या"
  },
  "roomDialog": {
    "desc_intro": "अपनी चित्रकला पर सहयोग करने के लिए लोगों को आमंत्रित करें।",
    "desc_privacy": "चिंता न करें, सत्र शुरू से अंत तक कूट रूप में है, और पूरी तरह से निजी है। यहां तक ​​कि हमारा परिसेवक भी यह नहीं देख सकता कि आप क्या बनाते हैं।",
    "button_startSession": "सत्र प्रारंभ करें",
    "button_stopSession": "सत्र समाप्त करें",
    "desc_inProgressIntro": "जीवंत सहयोग सत्र अब जारी है।",
    "desc_shareLink": "इस लिंक को आप जिस किसी के साथ भी सहयोग करना चाहते हैं, उसके साथ साझा करें",
    "desc_exitSession": "सत्र रोकना आपको रूम से बाहर कर देगा, किंतु आप स्थानीय स्तर पर दृश्य के साथ काम करना जारी रख सकते हो। ध्यान दें कि यह अन्य लोगों को प्रभावित नहीं करेगा, और वे अभी भी अपने संस्करण पर सहयोग करने में सक्षम होंगे।",
    "shareTitle": "जीवंत सहयोग सत्र में जुड़े"
  },
  "errorDialog": {
    "title": "त्रुटि"
  },
  "exportDialog": {
    "disk_title": "डिस्क पर सुरक्षित करे",
    "disk_details": "दृश्य डेटा एक फ़ाइल में निर्यात करे, जहांसे आप उसे पुनः आयात कर सके",
    "disk_button": "फ़ाइल में सुरक्षित करें",
    "link_title": "साझा करने योग्य कड़ी",
    "link_details": "केवल पढ़ी जा सके ऐसी कड़ी में निर्यात करें",
    "link_button": "कड़ी स्वरूप में निर्यात करे",
    "excalidrawplus_description": "दृश्य को एक्सकालीड्रॉप्लस कार्यस्थल में सुरक्षित रखें",
    "excalidrawplus_button": "निर्यात",
    "excalidrawplus_exportError": "इस वक्त एक्सकालीड्रॉप्लस में निर्यात नहीं किया जा सका..."
  },
  "helpDialog": {
    "blog": "हमारा ब्लॉग पढे",
    "click": "क्लिक करें",
    "deepSelect": "गहरा चयन",
    "deepBoxSelect": "बक्से के अंदर गहरा चयन करे और घसीटने की रोकथाम करे",
    "createFlowchart": "सामान्य अवयव से फ़्लोचार्ट बनायें",
    "navigateFlowchart": "फ़्लोचार्ट का अनुपालन करें",
    "curvedArrow": "वक्र तीर",
    "curvedLine": "वक्र रेखा",
    "documentation": "प्रलेखिकरण",
    "doubleClick": "डबल-क्लिक",
    "drag": "खींचें",
    "editor": "संपादक",
    "editLineArrowPoints": "रेखा/तीर बिंदु सम्पादित करे",
    "editText": "पाठ्य सम्पादित करे/ लेबल जोड़े",
    "github": "मुद्दा मिला? प्रस्तुत करें",
    "howto": "हमारे गाइड का पालन करें",
    "or": "या",
    "preventBinding": "तीर बंधन रोकें",
    "tools": "उपकरण",
    "shortcuts": "कीबोर्ड के शॉर्टकट्स",
    "textFinish": "संपादन पूर्ण करे (पाठ संपादक)",
    "textNewLine": "नई पंक्ति जोड़ें (पाठ संपादक)",
    "title": "मदद",
    "view": "दृश्य",
    "zoomToFit": "सभी अवयाओं को फिट करने के लिए ज़ूम करें",
    "zoomToSelection": "चयन तक ज़ूम करे",
    "toggleElementLock": "ताले के अंदर/बाहर चुनाव",
    "movePageUpDown": "पृष्ठ ऊपर/नीचे करे",
    "movePageLeftRight": "पृष्ठ बायी/दायी तरफ करे",
    "cropStart": "प्रतिमा काटें",
    "cropFinish": "प्रतिमा काटना समाप्त करें"
  },
  "clearCanvasDialog": {
    "title": "चित्रपलट स्वच्छ करे"
  },
  "publishDialog": {
    "title": "समूह कोष प्रकाशित करे",
    "itemName": "वस्तु का नाम",
    "authorName": "लेखक का नाम",
    "githubUsername": "ग़िटहब उपयोक्ता का नाम",
    "twitterUsername": "ट्विटर उपयोक्ता का नाम",
    "libraryName": "समूहकोष का नाम",
    "libraryDesc": "समूहकोष विवरण",
    "website": "वेबसाइट",
    "placeholder": {
      "authorName": "आपका नाम अथवा उपयोक्तानाम",
      "libraryName": "आपके समूहकोष का नाम",
      "libraryDesc": "आपके समूह कोष का विवरण, जिससे अन्य उपयोक्ता उसका उपयोग समझ सके",
      "githubHandle": "ग़िट हब हैंडल (वैकल्पिल), जिससे आप समूह कोष को उसके एक बार समीक्षा के लिये प्रस्तुत करने के उपरांत संपादित कर सके.",
      "twitterHandle": "ट्विटर उपयोक्ता का नाम ( ऐच्छिक), जिससे हम ट्विटर पर प्रवर्तन करते समय उचित उपयोक्ता को श्रेय दे सके",
      "website": "आपकी व्येयक्तिक वेब साइट या अन्य साइट की कड़ी ( ऐच्छिक)"
    },
    "errors": {
      "required": "आवश्यक",
      "website": "मान्य URL दर्ज करें"
    },
    "noteDescription": "अन्य वक्तियों को उनके चित्रकारी में उपयोग के लिये आपका संग्रह <link> सार्वजनिक समग्रहालय</link> में सम्मिलित करने हेतु प्रस्तुत करें.",
    "noteGuidelines": "संग्रह को पहले स्वीकृति मिलना आवश्यक कृपया हैं. दिए हुवे <link>दिशा-निर्देश</link> पढ़े. संचार और बदलने के लिए आपके पास एक ग़िट हब खाता होना चाहिए है. परंतु, यह अति आवश्यक नाही हैं.",
    "noteLicense": "जमा करके, आप मानते है कि आप सहमत हैं कि संग्रहण को <link>MIT लाइसेंस</link> के तहत प्रकाशित किया जाएगा, जिसका संक्षिप्त अर्थ है कि कोई भी बिना किसी प्रतिबंध के उनका उपयोग कर सकता है।",
    "noteItems": "प्रत्तेक समूह कोष अवयव का उसका नाम होना आवश्यक हैं, जिसे उसे छान कर तलाशा जा सकें",
    "atleastOneLibItem": "प्रारम्भ करने के लिये समूह कोष से कम से कम एक अवयव चुने",
    "republishWarning": "टिप्पणी: कुछ चुने हुवे आइटम पहले ही प्रकाशित/प्रस्तुत किए जा चुके हैं। किसी प्रकाशित संग्रह को अद्यतन करते समय या पहले से प्रस्तुत अवयवों को पुन्हा प्रस्तुत करते समय, आप बस उसे केवल अद्यतन करें ।"
  },
  "publishSuccessDialog": {
    "title": "समूह कोष प्रस्तुत करें",
    "content": "{{authorName}} धन्यवाद. आपका संग्रहण समीक्षा के लिए दर्ज हो चुका है. समीक्षा स्थिति <link>यहाँ</link>जान सकते हैं."
  },
  "confirmDialog": {
    "resetLibrary": "संग्रह को पुनः स्थापित करें",
    "removeItemsFromLib": "चयनित अवयव समूह कोष से अलग करें"
  },
  "imageExportDialog": {
    "header": "प्रतिमा निर्यात करे",
    "label": {
      "withBackground": "पृष्ठभूमि",
      "onlySelected": "केवल चयनित",
      "darkMode": "कम प्रकाश प्रणाली",
      "embedScene": "दृश्य जड़े",
      "scale": "परिमाप",
      "padding": "भराई"
    },
    "tooltip": {
      "embedScene": "दृश्य डेटा निर्यतित पी-एन-जी/ एस-वी-जी फ़ाइल में सुरक्षित किया जाएगा, जिससे दृश्य को पुनःस्थापित किया जा सकता है. यह निर्यतित फ़ाइल का आकार बढ़ा देगा."
    },
    "title": {
      "exportToPng": "पी-एन-जी के स्वरूप में निर्यात करे",
      "exportToSvg": "एस-वी0जी के स्वरूप में निर्यात करे",
      "copyPngToClipboard": "पी-एन-जी के स्वरूप में क्लिपबोर्ड पर प्रतिरूपित करें"
    },
    "button": {
      "exportToPng": "पी-एन-जी",
      "exportToSvg": "एस-वी-जी",
      "copyPngToClipboard": "क्लिपबोर्ड पर प्रतिलिपि बनाएँ"
    }
  },
  "encrypted": {
    "tooltip": "आपके चित्र अंत-से-अंत एन्क्रिप्टेड हैं, इसलिए एक्सक्लूसिव्रॉव के सर्वर उन्हें कभी नहीं देखेंगे।",
    "link": "एक्सकाली मैं ब्लॉग पोस्ट आद्यंत गोपित"
  },
  "stats": {
    "angle": "कोण",
    "shapes": "आकृतियाँ",
    "height": "ऊंचाई",
    "scene": "दृश्य",
    "selected": "चयनित",
    "storage": "संग्रह",
    "fullTitle": "पटल और आकार के गुण",
    "title": "गुण",
    "generalStats": "साधारणत:",
    "elementProperties": "आकृति के गुण",
    "total": "कुल",
    "version": "संस्करण",
    "versionCopy": "प्रतिलिपि के लिए क्लिक करें",
    "versionNotAvailable": "संस्करण उपलब्ध नहीं है",
    "width": "चौड़ाई"
  },
  "toast": {
    "addedToLibrary": "समूहकोष में जोडा गया",
    "copyStyles": "प्रतिलिपित शैली",
    "copyToClipboard": "क्लिपबोर्ड में प्रतिलिपित",
    "copyToClipboardAsPng": "{{exportSelection}} को क्लिपबोर्ड पर पी-एन-जी( {{exportColorScheme}}) पर प्रतिरूपित किया गया",
    "copyToClipboardAsSvg": "{{exportSelection}} को क्लिपबोर्ड पर एस-वी-जी ( {{exportColorScheme}}) स्वरूप में प्रतिलिपित किया",
    "fileSaved": "फ़ाइल सुरक्षित की गयी",
    "fileSavedToFilename": "{filename} में सुरक्षित की गयी",
    "canvas": "चित्रपटल",
    "selection": "चयन",
    "pasteAsSingleElement": "एक अवयव के रूप में चिपकाने के लिए {{shortcut}} का उपयोग करें,\nया किसी मौजूदा पाठ संपादक में चिपकायें",
    "unableToEmbed": "यह यू-आर-एल जड़ने हेतु अस्वीकृत हैं. इस यू-आर-एल को श्वेतसूची मैं सम्मिलित कराने हेतु ग़िटहब पर मुद्दा उठायें",
    "unrecognizedLinkFormat": "जो कड़ी आपने जड़ी हैं, वह अनपेक्षित प्रारूप में हैं. कृपया मूल साइट द्वारा मुहैय्या कराया हुवा 'जड़ने हेतु' पाठ चिपकाने का प्रयास करें.",
    "elementLinkCopied": "कड़ी क्लिप बोर्ड पर कॉपी की गयी"
  },
  "colors": {
    "transparent": "पारदर्शक",
    "black": "काला",
    "white": "सफ़ेद",
    "red": "लाल",
    "pink": "गुलाबी",
    "grape": "अंगूरी",
    "violet": "जामुनी",
    "gray": "गहरा",
    "blue": "नीला",
    "cyan": "आसमानी",
    "teal": "हरा-नीला",
    "green": "हरा",
    "yellow": "पीला",
    "orange": "नारंगी",
    "bronze": "कांस्य"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "बजाय आपको एक्स-काली-ड्रॉ-प्लस पर जाना है?",
      "menuHint": "निर्यात, पसंद, भाषायें, ..."
    },
    "defaults": {
      "menuHint": "निर्यात, पसंद, और भी...",
      "center_heading": "चित्रांकन। बनाया गया। सरल।",
      "toolbarHint": "एक औजार चुने और चित्रकारी प्रारंभ करे!",
      "helpHint": "शॉर्ट्कट और सहाय्य"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "अधिकांश उपयोगित रंग",
    "colors": "रंग",
    "shades": "छाया",
    "hexCode": "हेक्स कोड",
    "noShades": "इस रंग की कोई छाया उपलब्ध नहीं हैं"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "प्रतिमा स्वरूप में निर्यात करे",
        "button": "प्रतिमा स्वरूप में निर्यात करे",
        "description": "दृष्य डेटा प्रतिमा स्वरूप में निर्यात करे, उस स्वरूप से आप उसे पुनः आयात कर सकते हो"
      },
      "saveToDisk": {
        "title": "डिस्क में सम्हाले",
        "button": "डिस्क में सम्हाले",
        "description": "दृष्य डेटा बाहरी फ़ाइल में निर्यात करे, जहाँसे आप उसे पुनः आयात कर सकते हो"
      },
      "excalidrawPlus": {
        "title": "एक्स-काली-ड्रॉ-प्लस",
        "button": "एकस-काल-ड्रॉ-प्लस में निर्यात करे",
        "description": "दृष्य को आपके एक्स-काली-ड्रॉ-प्लस के कर्यस्थल में सम्हाले"
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "फ़ाइल से लोड करें:",
        "button": "फ़ाइल से लोड करें:",
        "description": "फ़ाइल से लोड करने पर <bold>यह आपके कार्य की जगह लेलेगा </bold><br></br>आपकी ड्रॉइंग निम्न दर्शित विकल्पो में से एक चुनके और उपयोग करके सहेज सकते हैं"
      },
      "shareableLink": {
        "title": "लिंक से लोड करें:",
        "button": "मेरी सामग्री बदले",
        "description": "बाहर का चित्र लोड करने पर <bold>यह आपके कार्य की जगह लेलेगा </bold><br></br>आप आपकी ड्रॉइंग पहले निम्न दर्शित विकल्पो में से एक चुनके और उपयोग करके सहेज सकते हों."
      }
    }
  },
  "mermaid": {
    "title": "मर्मेड से एक्सकाली में",
    "button": "सन्निवेश करे",
    "description": "वर्तमान में केवल <flowchartLink>बहाव चित्र</flowchartLink>, <sequenceLink> अनुक्रम चित्र </sequenceLink> और <classLink>वर्ग चित्र</classLink> का चित्रिकरण संभव हैं. अन्य चित्र प्रकार एक्सकाली प्रतिमा जैसे चित्रित किए जायेंगे.",
    "syntax": "मर्मेड विन्यास",
    "preview": "पूर्वावलोकन",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "त्वरित खोज"
  },
  "fontList": {
    "badge": {
      "old": "पुराना"
    },
    "sceneFonts": "इस दृश्य में",
    "availableFonts": "उपलब्ध लिपियां",
    "empty": "कोई लिपि नहीं मिली"
  },
  "userList": {
    "empty": "कोई उपयोक्ता नहीं मिला",
    "hint": {
      "text": "उपयोक्ता का अनुकरण करने के लिए उसपर क्लिक करें",
      "followStatus": "आप इस उपयोक्ता का अनुकरण कर रहें हैं.",
      "inCall": "व्यक्ति अभी संभाषण मैं व्यस्त हैं",
      "micMuted": "व्यक्ति का माइक्रोफ़ोन अभी मूक अवस्था मैं हैं",
      "isSpeaking": "व्यक्ति अभी बोलने मैं व्यस्त हैं"
    }
  },
  "commandPalette": {
    "title": "आदेश फ़लक",
    "shortcuts": {
      "select": "चुनें",
      "confirm": "पुष्टि करें",
      "close": "बंद करें"
    },
    "recents": "हाल ही में उपयोग किया गया",
    "search": {
      "placeholder": "मेनू, आदेशों कों धूंड़े और गुप्त नग प्राप्त करें",
      "noMatch": "कोई आदेश मेल नाही खा सका....."
    },
    "itemNotAvailable": "आदेश उपलब्ध नाही हैं.",
    "shortcutHint": "आदेश फलक के लिए, {{shortcut}} का उपयोग कीजिए"
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
